export const manifest = {
  screens: {
    scr_ryzus6: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_6y6t6n: { name: "Sign up — Landing", route: "/signup", state: {"step":1}, position: {"x":160,"y":2200} },
    scr_8jq2yu: { name: "Slack consent", route: "/signup", state: {"step":2}, position: {"x":1560,"y":2200} },
    scr_fylw3v: { name: "Slack permissions", route: "/signup", state: {"step":3}, position: {"x":2960,"y":2200} },
    scr_ivnco7: { name: "Choose channels", route: "/signup", state: {"step":4}, position: {"x":4360,"y":2200} },
    scr_ah2wo2: { name: "About you", route: "/signup", state: {"step":5}, position: {"x":5760,"y":2200} },
    scr_omt78o: { name: "Tool picker", route: "/signup", state: {"step":6}, position: {"x":7160,"y":2200} },
    scr_9gr5ba: { name: "Connections", route: "/signup", state: {"step":7}, position: {"x":8560,"y":2200} },
    scr_injbnc: { name: "Now go to Slack", route: "/signup", state: {"step":8}, position: {"x":9960,"y":2200} },
    scr_sfdb81: { name: "Slack — Giga DM", route: "/signup", state: {"step":9}, position: {"x":11360,"y":2200} },
    scr_8f0skm: { name: "Welcome back", route: "/signup", state: {"step":10}, position: {"x":12760,"y":2200} },
    scr_yvq2cz: { name: "Start your trial", route: "/signup", state: {"step":11}, position: {"x":14160,"y":2200} },
    scr_mxxj8o: { name: "Client Management", route: "/use-cases/client-management", position: {"x":160,"y":4180} },
    scr_xhpoc8: { name: "Growth & Marketing", route: "/use-cases/growth-marketing", position: {"x":1560,"y":4180} },
    scr_e1i5ji: { name: "Founders & Execs", route: "/use-cases/founders-execs", position: {"x":2960,"y":4180} },
    scr_2i9k3d: { name: "Pricing", route: "/pricing", position: {"x":160,"y":6160} },
    scr_mhpjmw: { name: "Bespoke", route: "/bespoke", position: {"x":160,"y":14080} },
    scr_uconpq: { name: "Blog", route: "/blog", position: {"x":2960,"y":8140} },
    scr_sl86jc: { name: "Research", route: "/research", position: {"x":1560,"y":8140} },
    scr_cb21wf: { name: "Case Studies", route: "/case-studies", position: {"x":160,"y":8140} },
    scr_xd5o9w: { name: "Changelog", route: "/changelog", position: {"x":4360,"y":8140} },
    scr_pd9uqn: { name: "Security", route: "/security", position: {"x":5760,"y":8140} },
    scr_jgq2zv: { name: "Compare — ChatGPT", route: "/compare/chatgpt", position: {"x":160,"y":10120} },
    scr_eldpu2: { name: "Watch Giga work", route: "/demo", position: {"x":160,"y":12100} },
    scr_b6vq1n: { name: "Book a demo", route: "/demo/book", position: {"x":1560,"y":12100} },
    scr_zhfffe: { name: "Architecture Home", route: "/architecture", position: {"x":7160,"y":8140} },
  },
  sections: {
    sec_16437l: { name: "Home", x: 0, y: 0, width: 4320, height: 1180 },
    sec_q5m936: { name: "Sign up flow", x: 0, y: 1980, width: 15520, height: 1180 },
    sec_a5hi1s: { name: "Use Cases", x: 0, y: 3960, width: 4320, height: 1180 },
    sec_16dxlv: { name: "Pricing", x: 0, y: 5940, width: 1520, height: 1180 },
    sec_4fhzmy: { name: "Content & Resources", x: 0, y: 7920, width: 8520, height: 1180 },
    sec_ragkln: { name: "Comparisons", x: 0, y: 9900, width: 1520, height: 1180 },
    sec_9lgnx9: { name: "Product Demo", x: 0, y: 11880, width: 2920, height: 1180 },
    sec_lolr7p: { name: "Bespoke", x: 0, y: 13860, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_16437l", children: [
      { kind: "screen", id: "scr_ryzus6" },
      { kind: "screen", id: "scr_uqe2cg" },
    ] },
    { kind: "section", id: "sec_q5m936", children: [
      { kind: "screen", id: "scr_6y6t6n" },
      { kind: "screen", id: "scr_8jq2yu" },
      { kind: "screen", id: "scr_fylw3v" },
      { kind: "screen", id: "scr_ivnco7" },
      { kind: "screen", id: "scr_ah2wo2" },
      { kind: "screen", id: "scr_omt78o" },
      { kind: "screen", id: "scr_9gr5ba" },
      { kind: "screen", id: "scr_injbnc" },
      { kind: "screen", id: "scr_sfdb81" },
      { kind: "screen", id: "scr_8f0skm" },
      { kind: "screen", id: "scr_yvq2cz" },
    ] },
    { kind: "section", id: "sec_a5hi1s", children: [
      { kind: "screen", id: "scr_mxxj8o" },
      { kind: "screen", id: "scr_xhpoc8" },
      { kind: "screen", id: "scr_e1i5ji" },
    ] },
    { kind: "section", id: "sec_16dxlv", children: [
      { kind: "screen", id: "scr_2i9k3d" },
    ] },
    { kind: "section", id: "sec_4fhzmy", children: [
      { kind: "screen", id: "scr_cb21wf" },
      { kind: "screen", id: "scr_sl86jc" },
      { kind: "screen", id: "scr_uconpq" },
      { kind: "screen", id: "scr_xd5o9w" },
      { kind: "screen", id: "scr_pd9uqn" },
      { kind: "screen", id: "scr_zhfffe" },
    ] },
    { kind: "section", id: "sec_ragkln", children: [
      { kind: "screen", id: "scr_jgq2zv" },
    ] },
    { kind: "section", id: "sec_9lgnx9", children: [
      { kind: "screen", id: "scr_eldpu2" },
      { kind: "screen", id: "scr_b6vq1n" },
    ] },
    { kind: "section", id: "sec_lolr7p", children: [
      { kind: "screen", id: "scr_mhpjmw" },
    ] },
  ],
}
